<template>
	<v-card flat outlined class="pb-0 pt-0">
		<v-card-text class="pb-0 pt-0">
			<v-row class="pb-0">
				<v-col v-if="registration > 0" class="d-flex justify-end align-center pl-2 pb-0">
					<v-btn @click="addManually" class="mr-2" :disabled="!surveyExists">
						{{ $t('buttons.addManually') }}
						<v-icon small class="ml-2">fas fa-user-plus</v-icon>
					</v-btn>
					<v-btn @click="sendSurveysAgain" color="primary" class="mr-2" :disabled="!surveyExists">
						{{ $t('buttons.sendSurveysAgain') }}
						<v-icon small class="ml-2">fas fa-paper-plane</v-icon>
					</v-btn>
					<v-btn @click="generateSurveys" color="primary" class="mr-2" :disabled="surveyExists">
						{{ $t('buttons.generateSurveys') }}
						<v-icon small class="ml-2">fas fa-plus</v-icon>
					</v-btn>
				</v-col>
			</v-row>
			<v-row class="pb-0 pt-0">
				<v-col cols="5" class="pr-0 pl-0">
					<SurveyCandidates></SurveyCandidates>
				</v-col>
				<v-col v-if="surveyExists" cols="7" class="pr-0 pl-0">
					<SurveyStats></SurveyStats>
				</v-col>
			</v-row>
			<v-row v-if="showModal">
				<v-col>
					<Modal :show-modal="showModal">
						<template v-slot:title>
							<v-row class="d-flex justify-space-between">
								<v-col></v-col>
								<v-col class="d-flex justify-center">
									<div :class="['text-h6', 'pa-2']">
										{{ $t('titles.survey') }}
									</div>
								</v-col>
								<v-col class="d-flex justify-end">
									<div :class="['text-body-2', 'pt-2', 'pb-0']">
										{{ $t('labels.obSurveyNumber') }}
									</div>
								</v-col>
							</v-row>
							<br />
							<div :class="['text-subtitle-1']" style="display: block; width: 100%; text-align: center">
								{{ $t('texts.surveyRatingInfo') }}
							</div>
						</template>
						<Survey @close="closeModal" :inEditMode="inEditMode"></Survey>
					</Modal>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
import SurveyCandidates from './SurveyCandidates';
import SurveyStats from './SurveyStats';
import Survey from './Survey';
import Modal from '../../trinkets/Modal';

export default {
	name: 'Surveys',
	components: { SurveyCandidates, SurveyStats, Survey, Modal },
	data() {
		return {
			showModal: false,
			inEditMode: false,
			surveyExists: false,
		};
	},
	props: {
		registration: [String, Number],
	},
	methods: {
		addManually() {
			this.showModal = true;
			this.inEditMode = true;
		},
		closeModal() {
			this.showModal = false;
			this.inEditMode = false;
		},
		checkSurveyExistance() {
			let vm = this;
			this.$APICall('get', 'surveys-existance/' + this.$route.params.id, {}, (data, success) => {
				if (success) {
					vm.surveyExists = data.existance;
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			});
		},
		generateSurveys() {
			let vm = this;
			this.$verify(this.$t('alerts.generateSurveysQuestion'), (result) => {
				if (result) {
					this.$APICall('get', 'surveys-generation/' + this.$route.params.id, {}, (data, success) => {
						if (success) {
							vm.$notify(vm.$t('alerts.surveyGenerationSuccess'));
							vm.surveyExists = true;
							vm.$modalBus.$emit('reloadSurveyCandidates');
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
					});
				}
			});
		},
		sendSurveysAgain() {
			let vm = this;
			this.$verify(this.$t('alerts.sendSurveysAgainAlert'), (result) => {
				if (result) {
					this.$APICall('get', 'surveys-send/' + this.$route.params.id, {}, (data, success) => {
						if (success) {
							vm.$notify(vm.$t('alerts.surveySendingSuccess'));
							vm.surveyExists = true;
							vm.$modalBus.$emit('reloadSurveyCandidates');
							vm.$modalBus.$emit('reloadSurveyStats');
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
					});
				}
			});
		},
	},
	mounted() {
		this.checkSurveyExistance();
	},
};
</script>

<style scoped></style>
